import { FC, useState } from 'react';
import { Col, Form, Input, Modal, Row, Select, message as messageApi } from 'antd';
import AlertC from '../../components/Alert/Alert';
import { doc, getFirestore, runTransaction } from "firebase/firestore";
import "../../firebase/firebase";
import { BuyerData } from "../../interfaces/buyer";
import { states } from "../../utils/constants";

const db = getFirestore();

interface RafflesModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (buyerData: BuyerData) => void;
  ticketIds: string[];
}

const HomeModal: FC<RafflesModalProps> = ({ open, onClose, onSuccess, ticketIds }) => {
  const [formModal, setFormModal] = useState<BuyerData>({ buyer: "", phone: "", state: "" });
  const [saving, setSaving] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [form] = Form.useForm();

  const onAccept = async () => {
    if (saving) return;

    try {
      setSaving(true);

      await runTransaction(db, async (transaction) => {
        const ticketRefs = ticketIds.map(id => doc(db, "tickets", id));

        const ticketSnapshots = await Promise.all(
          ticketRefs.map(ref => transaction.get(ref))
        );

        for (const snap of ticketSnapshots) {
          if (!snap.exists()) {
            throw new Error(`El ticket ${snap.id} no existe.`);
          }

          if (snap.data().status === "Reservado") {
            throw new Error(`El ticket ${snap.data().number} ya se encuentra reservado.`);
          }
        }

        ticketRefs.forEach((ref) => {
          transaction.update(ref, {
            status: "Reservado",
            reservationDate: new Date(),
            ...formModal
          });
        });
      });

      setMessage("Apartado realizado con éxito!");
      setTimeout(() => setMessage(""), 4000);
      onSuccess(formModal);
      onClose();

    } catch (error: any) {
      console.error("Error en la reserva:", error.message);
      messageApi.warning(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Modal
        okButtonProps={{
          style: { backgroundColor: "orangered" }
        }}
        open={open}
        cancelText="Cancelar"
        okText="Reservar"
        onCancel={() => onClose()}
        onOk={() =>
          form.validateFields()
            .then(async () => {
              await onAccept();
            })
        }
        confirmLoading={saving}
        maskClosable={false}
      >
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          <div style={{ color: "red", fontSize: 20 }}>NOTA IMPORTANTE!!</div>
          <div>
            Los números reservados deberán pagarse máximo en 24 horas o serán liberados por el sistema.
          </div>
          <div style={{ color: "blueviolet", fontSize: 20, paddingTop: 10 }}>
            Banco Azteca
          </div>
          <div>
            4027 6600 1127 3770
          </div>
          <div>
            Julian Ernesto Vasquez Silva
          </div>
          <div style={{ color: "blueviolet", fontSize: 20, paddingTop: 10 }}>
            Spin Oxxo
          </div>
          <div>
            4217 4701 1513 1290
          </div>
          <div>
            Cuenta CLABE: 728969000144122898
          </div>
          <div>
            Julian Ernesto Vasquez Silva
          </div>
          <br />
          <div>
            SI EL PAGO ES POR TRANSFERENCIA COLOCA EN EL CONCEPTO NUMERO DE TELEFONO REGISTRADO
          </div>
          <br />
        </div>
        <Form
          form={form}
          layout="vertical"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Nombre"
                name="name"
                rules={[{ required: true, message: 'Favor de escribir tu nombre' }]}
              >
                <Input value={formModal.buyer} onChange={(e) => setFormModal({ ...formModal, buyer: e.target.value })} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Teléfono"
                name="phone"
                rules={[{ required: true, len: 10, message: 'Favor de escribir tu teléfono a 10 dígitos' }]}
              >
                <Input
                  type="number"
                  value={formModal.phone}
                  onChange={(e) => setFormModal({ ...formModal, phone: e.target.value })}
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </Form.Item>
            </Col>
            <Col xs={24} >
              <Form.Item
                label="Estado"
                name="state"
                rules={[{ required: true, message: 'Favor seleccionar tu estado' }]}
              >
                <Select
                  value={formModal.state}
                  onChange={(value) => {
                    setFormModal({ ...formModal, state: value });
                  }}
                >
                  {
                    states.map((state) => (
                      <Select.Option value={state} key={state}>{state}</Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AlertC
        open={Boolean(message)}
        onClose={() => setMessage("")}
        severity="success"
        message={message}
      />
    </>
  );
};

export default HomeModal;
